import moment from 'moment';
import { DBO_TM } from '@op/utils/format';
import { GAME_CATEGORY } from '@opm/components/FilterCommon/constants/games';

export const MATERIALS_LIST_API = 'materials/list';
export const COMPETITOR_AD_LIST_API = 'ad_creative_multi';



export interface IMaterialsListDefaultFilter {
  start_time: string;
  end_time: string;
  date_type: 'daily';
}

/** 品类 → 最新数据日期的映射 */
export type TByGameGenre = Record<string, string>;

export function dealwithMaterialsList(id: string) {
  return (data: any): {
    defaultFilter?: IMaterialsListDefaultFilter;
    zoneGameIds?: string[];
    byGameGenre?: TByGameGenre;
  } => {
    const result: {
      defaultFilter?: IMaterialsListDefaultFilter;
      zoneGameIds?: string[];
      byGameGenre?: TByGameGenre;
    } = {};

    if (data.gameIds?.length) {
      result.zoneGameIds = data.gameIds;
    }

    const today: string | undefined = data?.config?.[id]?.today;
    if (!today) {
      return result;
    }

    const endDate = today;
    const startDate = moment(endDate).subtract(6, 'day').format('YYYY-MM-DD');
    const timeRange = DBO_TM.serverTimeObj([startDate, endDate], 'daily');

    result.defaultFilter = {
      start_time: timeRange.start_time,
      end_time: timeRange.end_time,
      date_type: 'daily',
    };

    // 提取品类 → 最新日期映射（日期值统一转为 YYYY-MM-DD 格式，与 defaultFilter 一致）
    // 同时将全局 today 以 GAME_CATEGORY.ALL 为 key 注入，供 Hook 切换 All Games 时使用
    const rawByGameGenre: Record<string, string> | undefined = data?.config?.[id]?.by_game_genre;
    if (rawByGameGenre || today) {
      result.byGameGenre = {};
      if (rawByGameGenre) {
        for (const [key, dateStr] of Object.entries(rawByGameGenre)) {
          const d = moment(dateStr);
          result.byGameGenre[key] = d.isValid() ? d.format('YYYY-MM-DD') : dateStr;
        }
      }
      const d = moment(today);
      result.byGameGenre[GAME_CATEGORY.ALL] = d.isValid() ? d.format('YYYY-MM-DD') : today;
    }

    return result;
  };
}
